export const SIZES = {
  sm: "sm",
  md: "md",
  default: "default",
  lg: "lg",
};
